export default "__VITE_ASSET__Mllu0n6D__"